import { COUNTRIES } from '../core/constants/countries'
import {
  DEFAULT_ASYNC_LOADING_OPTIONS,
  DEFAULT_LOADING_PAGE_SIZE,
  DEFAULT_MAX_PAGE_SIZE,
  DEFAULT_MOUNT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE_COURSE,
  DEFAULT_SIZE_COLUMN,
  INFINITY_SIZE_COLUMN,
  MAPPING_TABLE_SIZE_COLUMN,
  MAX_SIZE_FREEZE_COLUMN
} from '../core/constants/enum'
import {
  APP_ENVIRONMENT,
  DEFAULT_LOCALE,
  NODE_ENV,
  PUBLIC_APP_DOMAIN,
  PUBLIC_EMAIL_HELP,
  PUBLIC_LANDING_PAGE_URL,
  PUBLIC_SENTRY_DSN,
  SENTRY_DSN
} from '../core/constants/env'
import { ROLE } from '../core/constants/role'
import { ICONS_SOCIAL } from '../core/constants/social'
import apiConfiguration from './api'
import keyConfiguration from './key'
import pathConfiguration from './path'
import seoConfiguration from './seo'

const configuration = {
  site: {
    locale: DEFAULT_LOCALE
  },
  path: pathConfiguration,
  api: apiConfiguration,
  key: keyConfiguration,
  seo: seoConfiguration,
  environment: APP_ENVIRONMENT,
  production: NODE_ENV === 'production',
  sentry: {
    dsn: SENTRY_DSN || PUBLIC_SENTRY_DSN
  },
  mailto: PUBLIC_EMAIL_HELP,
  appDomain: PUBLIC_APP_DOMAIN,
  appUrl: PUBLIC_LANDING_PAGE_URL,
  defaultPageSize: DEFAULT_PAGE_SIZE,
  defaultMaxPageSize: DEFAULT_MAX_PAGE_SIZE,
  defaultTableMountPageSize: DEFAULT_MOUNT_PAGE_SIZE,
  defaultTableLoadingPageSize: DEFAULT_LOADING_PAGE_SIZE,
  defaultCoursePageSize: DEFAULT_PAGE_SIZE_COURSE,
  defaultAsyncLoadingOptions: DEFAULT_ASYNC_LOADING_OPTIONS,
  tableColumnSize: {
    default: DEFAULT_SIZE_COLUMN,
    maxFreeze: MAX_SIZE_FREEZE_COLUMN,
    infinity: INFINITY_SIZE_COLUMN,
    mapping: MAPPING_TABLE_SIZE_COLUMN
  },
  countries: COUNTRIES,
  role: ROLE,
  iconSocial: ICONS_SOCIAL,
  downloadExt:
    'https://chromewebstore.google.com/detail/hireforce-sourcing/pbabkjheknegnbnnfmlojibfdcffbfgj'
}

export default configuration
